import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import Clickable from '../../components/Clickable';
import Label from '../../components/Label';
import Grid from '../../components/Grid';
import Link from '../../components/Link';
import { loginMessages as messages } from '../../defineMessages';
import { SHOP_PATH, ACCOUNT_TYPE } from '../../constants';
import { redirectTo } from '../../actions/config';
import s from './Login.scss';
import BusinessButton from '../../components/BusinessButton/BusinessButton';

const Login = ({
  intl: { formatMessage },
  initialBasket,
  mode,
  dispatch,
  redirecting,
}) => {
  if (!redirecting && initialBasket && mode === ACCOUNT_TYPE.REDEEM) {
    dispatch(redirectTo({ pathname: SHOP_PATH }));
  }
  return (
    <div className={s.box}>
      <Label bold tag="h4" className={s.title}>
        {formatMessage({ ...messages.title })}
      </Label>
      <Label tag="h3" className={s.subTitle}>
        {formatMessage({ ...messages.subtitle })}
      </Label>
      <Grid container direction="column" className={s.options}>
        {mode !== ACCOUNT_TYPE.B2B && (
          <Grid item className={s.item}>
            <Label bold tag="h5">
              {formatMessage({ ...messages.redeemTitle })}
            </Label>
            <Label tag="h6">
              {formatMessage({ ...messages.redeemSubtitle })}
            </Label>
            <Clickable
              primary
              className={s.button}
              link={<Link to="/redeem" />}
            >
              <Label>{formatMessage({ ...messages.redeemButton })}</Label>
            </Clickable>
          </Grid>
        )}
        <Grid item className={s.item}>
          <Label bold tag="h5">
            {formatMessage({ ...messages.businessTitle })}
          </Label>
          <Label tag="h6">
            {formatMessage({ ...messages.businessSubtitle })}
          </Label>
          <BusinessButton
            primary
            className={s.button}
            label={formatMessage({ ...messages.loginButton })}
          />
        </Grid>
      </Grid>
    </div>
  );
};

Login.propTypes = {
  intl: PropTypes.shape().isRequired,
  initialBasket: PropTypes.bool,
  mode: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  redirecting: PropTypes.bool.isRequired,
};

Login.defaultProps = {
  initialBasket: null,
};

const mapState = state => ({
  countryCode: state.intl.countryCode,
  locale: state.intl.locale,
  currency: state.intl.currency,
  initialBasket: state.loading.initialBasket,
  mode: state.user.mode,
  redirecting: state.loading.redirecting,
});

export default compose(injectIntl, withStyles(s), connect(mapState))(Login);
